import { createApiClient } from '../services/ApiClient';
import * as types from './ActionTypes';



export function auth(){
    return (dispath: any) =>{
        const api = createApiClient();

        api.me({
            success:(data) =>{
                if(data.isAuth && data.isAccess) {
                    dispath({type: types.AUTH_USER_SUCcESS, payload: data});
                    api.getSettings({
                        success: (data) => {
                            dispath({ type: types.SET_SETTINGS, payload: data });
                        }
                    })
                } else if (!data.isAuth && data.isAccess)
                    api.redirect(window.location.href);
                else if(data.isAuth && !data.isAccess)
                    api.singout(window.location.href);
                else
                    if(window.top !== window.self) {
                        const noHeader = window.location.search.includes('source=lk2')
                        if(noHeader){
                            window.top.location.href = '/?source=lk2#/not-authorized';
                        } else {
                            window.top.location.href = '/#/not-authorized';
                        }
                    }
                    else{
                        const noHeader = window.location.search.includes('source=lk2')
                        if(noHeader){
                            window.location.href = '/?source=lk2#/not-authorized';
                        } else {
                            window.location.href = '/#/not-authorized';
                        }
                    }

            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/actions/auth.ts